import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';

const LazyEditOffer = lazy(() => import('./EditOffer'));

export const EditOffer: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazyEditOffer {...props} />
	</Suspense>
);
